import { render, staticRenderFns } from "./WebPartPricePlanSetting.vue?vue&type=template&id=4128daca&"
import script from "./WebPartPricePlanSetting.vue?vue&type=script&lang=js&"
export * from "./WebPartPricePlanSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports